import React from "react";
import { Outlet } from "react-router-dom";

type AuthGateProps = {
  isAuthed: boolean;
  fallback: React.ReactNode;
};

const AuthGate = ({ isAuthed, fallback }: AuthGateProps) => {
  return <>{isAuthed ? <Outlet /> : fallback}</>;
};

export default AuthGate;
